import {BaseContainerModel} from '../../base-container.model';
import { bl_crm_membership_points_ctrl_acc_RowClass } from '../../../dbschema';

export class MembershipPointsExpiryContainerModel extends BaseContainerModel {
    bl_crm_membership_points_ctrl_acc: bl_crm_membership_points_ctrl_acc_RowClass = new bl_crm_membership_points_ctrl_acc_RowClass();
}
